import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getInitialAssessmentCardio } from '../selectors/getInitialAssessmentCardio.selectors'
import { ICardioState } from '../store/cardio.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { CardioConstants } from '../store/cardio.constants'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveInitialAssessmentCardio() {
  const initalAssessmentCardio: ICardioState = yield select(getInitialAssessmentCardio)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = {
      ...pcrDoc,
      prNabc: { ...pcrDoc.prNabc, ...initalAssessmentCardio.prNabc },
      prPm: [initalAssessmentCardio.prPm],
      prCvAssess: initalAssessmentCardio.prCvAssess,
    }

    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveInitialAssessmentCardio() error: ${e}`))
    }
  }
}
export function* saveInitialAssessmentCardioSaga() {
  yield takeLatest([CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO], performWithMutexHOG, saveInitialAssessmentCardio)
}
